<template>
  <b-card>
    <b-card-body>
      <fieldset class="natural-survey-fieldset mb-2">
        <legend class="natural-survey-fieldset__legend">فريق المعاينة</legend>
        <div class="natural-survey-fieldset__body">
          <b-row
            class="inspection-crew"
            align-v="end"
          >
            <b-col
              cols="12"
              sm="6"
              lg="3"
            >
              <validation-provider
                #default="{ errors }"
                name="مسؤول المعاينة"
                vid="office_inspection_responsible_id"
              >
                <b-form-group
                  label="مسؤول المعاينة"
                  label-for="office_inspection_responsible_id"
                  class="mb-50"
                >
                  <v-select
                    id="office_inspection_responsible_id"
                    v-model="inspectionResponsibleId"
                    :options="employeeSelectOptions"
                    :reduce="employeeOptionReduce"
                    :get-option-label="employeeOptionLabel"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    :clearable="true"
                    :disabled="inspectionCrewBusy || !canEditInspectionCrew"
                    placeholder="اختر المسؤول"
                    @search="onEmployeeSearch"
                  >
                    <template #option="option">
                      <span class="ml-50"> {{ employeeOptionLabel(option) }}</span>
                    </template>
                    <template #selected-option="option">
                      <span class="ml-50"> {{ employeeOptionLabel(option) }}</span>
                    </template>
                  </v-select>
                </b-form-group>
                <small class="text-danger d-block">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              lg="3"
            >
              <validation-provider
                #default="{ errors }"
                name="السائق"
                vid="driver_id"
              >
                <b-form-group
                  label="السائق"
                  label-for="driver_id"
                  class="mb-50"
                >
                  <v-select
                    id="driver_id"
                    v-model="driverId"
                    :options="employeeSelectOptions"
                    :reduce="employeeOptionReduce"
                    :get-option-label="employeeOptionLabel"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    :clearable="true"
                    :disabled="inspectionCrewBusy || !canEditInspectionCrew"
                    placeholder="اختر السائق"
                    @search="onEmployeeSearch"
                  >
                    <template #option="option">
                      <span class="ml-50"> {{ employeeOptionLabel(option) }}</span>
                    </template>
                    <template #selected-option="option">
                      <span class="ml-50"> {{ employeeOptionLabel(option) }}</span>
                    </template>
                  </v-select>
                </b-form-group>
                <small class="text-danger d-block">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              lg="4"
            >
              <validation-provider
                #default="{ errors }"
                name="فريق المعاينة"
                vid="inspection_teams"
              >
                <b-form-group
                  label="فريق المعاينة"
                  label-for="inspection_teams"
                  class="mb-50"
                >
                  <v-select
                    id="inspection_teams"
                    v-model="inspectionTeams"
                    :options="employeeSelectOptions"
                    :reduce="employeeOptionReduce"
                    :get-option-label="employeeOptionLabel"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    :close-on-select="false"
                    :disabled="inspectionCrewBusy || !canEditInspectionCrew"
                    placeholder="اختر الأعضاء"
                    @search="onEmployeeSearch"
                  >
                    <template #option="option">
                      <span class="ml-50"> {{ employeeOptionLabel(option) }}</span>
                    </template>
                    <template #selected-option="option">
                      <span class="ml-50"> {{ employeeOptionLabel(option) }}</span>
                    </template>
                  </v-select>
                </b-form-group>
                <small class="text-danger d-block">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              v-if="canEditInspectionCrew"
              cols="12"
              lg="2"
              class="inspection-crew__save-col"
            >
              <b-button
                variant="primary"
                class="inspection-crew__save w-100 mb-50"
                :disabled="inspectionCrewBusy"
                @click="updateInspectionTeams"
              >
                <b-spinner
                  v-if="updatingInspectionTeams"
                  small
                  class="mr-1"
                />
                <span v-else>حفظ</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </fieldset>
      <fieldset class="natural-survey-fieldset mt-2 mb-2">
        <legend class="natural-survey-fieldset__legend">مرفقات الرفع الحقلي</legend>
        <div class="natural-survey-fieldset__body">
        <div
          v-if="attachmentsSectionLoading"
          class="natural-survey-loader d-flex flex-column align-items-center justify-content-center py-4"
        >
          <b-spinner
            variant="primary"
            label="جاري التحميل"
          />
          <span class="text-muted small mt-2">جاري تحميل المرفقات...</span>
        </div>
        <div
          v-else-if="attachmentFields.length"
          class="d-flex flex-wrap required-block-cards"
        >
          <fieldset
            v-for="group in attachmentGroups"
            :key="group.groupKey"
            class="w-100 mb-1 attachment-field-group natural-survey-fieldset"
            :class="attachmentGroupAccentClass(group)"
            :style="attachmentGroupCssVars(group)"
          >
            <legend class="natural-survey-fieldset__legend">{{ group.groupTitle }}</legend>
            <div class="d-flex flex-wrap required-block-cards natural-survey-fieldset__body">
              <b-card
                v-for="field in group.fields"
                :key="field.key"
                class="media-card mb-2 shadow-sm"
                body-class="p-1 d-flex flex-column align-items-center"
              >
                <!-- File preview -->
                
                <div class="media-file-details w-100 text-center mb-1">
                  <div
                    class="file-title"
                    style="word-break:break-all"
                  >
                    {{ field.label }}
                  </div>
                  <div
                    v-if="isFieldMultiple(field)"
                    class="file-meta text-muted small mt-1"
                  >
                    متعدد
                  </div>
                  <template v-if="getConditionalFiles(field.key).length">
                    <div
                      v-for="file in getConditionalFiles(field.key)"
                      :key="file.id || file.url || file.name"
                      class="lookup-file-item mt-1"
                    >
                      <div class="file-meta text-muted small mt-1">
                        {{ (file.extension || '').toUpperCase() }} • {{ file.human_readable_size }}
                      </div>
                      <div class="file-meta text-muted small mt-1">
                        {{ file.uploader ? file.uploader.name : '' }}
                      </div>
                      <div class="file-meta text-muted small mt-1">
                        {{ file.created_at | formatJalali }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="file-meta text-muted small mt-1">
                      غير موجود
                    </div>
                  </template>
                </div>

                <div class="w-100 mt-1">
                  <div class="d-flex align-items-center gap-1">
                    <b-form-file
                      v-model="fieldUploads[field.key]"
                      :state="hasSelectedFiles(field)"
                      :placeholder="isFieldMultiple(field) ? 'اختر ملفات' : 'اختر ملف'"
                      drop-placeholder="اسحب الملف هنا"
                      browse-text="تصفح"
                      :accept="fieldAccept(field)"
                      :multiple="isFieldMultiple(field)"
                      class="flex-grow-1 mb-0"
                    />
                    <b-button
                      v-b-tooltip.hover.top="getConditionalFile(field.key) ? (isFieldMultiple(field) ? 'إضافة' : 'تحديث') : 'رفع'"
                      size="sm"
                      variant="primary"
                      class="flex-shrink-0 btnSM"
                      :disabled="!hasSelectedFiles(field) || isUploadingConditional(field.key)"
                      @click="submitFieldUpload(field)"
                    >
                      <b-spinner
                        v-if="isUploadingConditional(field.key)"
                        small
                      />
                      <feather-icon
                        v-else
                        icon="UploadIcon"
                        size="12"
                      />
                    </b-button>
                  </div>
                </div>

                <!-- Notes + actions per uploaded file -->
                <div
                  v-for="file in getConditionalFiles(field.key)"
                  :key="`actions-${field.key}-${file.id || file.url}`"
                  class="w-100"
                >
                <div
                  class="media-card-notes w-100"
                >
                  <div
                    v-if="!editingNotes[file.id]"
                    class="notes-display"
                  >
                    <div
                      v-if="file.notes"
                      class="notes-content"
                    >
                      <p class="notes-text mb-0">
                        {{ file.notes }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-else
                    class="notes-edit"
                  >
                    <b-form-textarea
                      v-model="notesEdit[file.id]"
                      placeholder="أدخل الملاحظات..."
                      rows="3"
                      :disabled="savingNotes[file.id]"
                    />
                    <div class="d-flex gap-1">
                      <b-button
                        size="sm"
                        variant="primary"
                        class="flex-fill"
                        :disabled="savingNotes[file.id]"
                        @click="saveNote(file)"
                      >
                        <b-spinner
                          v-if="savingNotes[file.id]"
                          small
                          class="mr-1"
                        />
                        حفظ
                      </b-button>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="flex-fill"
                        :disabled="savingNotes[file.id]"
                        @click="cancelEditingNote(file.id)"
                      >
                        إلغاء
                      </b-button>
                    </div>
                  </div>
                </div>

                <div
                  class="media-card-actions d-flex flex-row justify-content-center gap-1 w-100"
                >
                  <b-button
                    v-if="file.is_image || file.is_video || file.is_document"
                    v-b-tooltip.hover.top="'معاينة'"
                    :href="file.url"
                    target="_blank"
                    size="sm"
                    class="btnSM"
                    variant="info"
                    @click="handleFileActionRefresh(field.key)"
                  >
                    <feather-icon icon="EyeIcon" size="12" />
                  </b-button>
                  <b-button
                    v-if="hasPermission('download media')"
                    v-b-tooltip.hover.top="'تحميل'"
                    :href="file.download_url || file.url"
                    target="_blank"
                    size="sm"
                    class="btnSM"
                    variant="success"
                    @click="handleFileActionRefresh(field.key)"
                  >
                    <feather-icon icon="DownloadIcon" size="12" />
                  </b-button>
                  <b-button
                    v-if="file.download_PDF_url && hasPermission('download media')"
                    v-b-tooltip.hover.top="'PDF تحميل'"
                    :href="file.download_PDF_url"
                    target="_blank"
                    size="sm"
                    class="btnSM"
                    variant="primary"
                    @click="handleFileActionRefresh(field.key)"
                  >
                    <feather-icon icon="DownloadCloudIcon" size="12" />
                  </b-button>
                  <b-button
                    v-if="hasPermission('delete media')"
                    v-b-tooltip.hover.top="'حذف'"
                    size="sm"
                    class="btnSM"
                    variant="danger"
                    @click="deleteConditionalFile(field.key, file.id)"
                  >
                    <feather-icon icon="Trash2Icon" size="12" />
                  </b-button>
                  <b-button
                    v-if="!editingNotes[file.id] && hasPermission('edit projects')"
                    v-b-tooltip.hover.top="file.notes ? 'تعديل الملاحظات' : 'إضافة ملاحظات'"
                    size="sm"
                    class="btnSM"
                    variant="outline-secondary"
                    @click="startEditingNote(file)"
                  >
                    <feather-icon icon="EditIcon" size="12" />
                  </b-button>
                </div>
                </div>
              </b-card>
                </div>
          </fieldset>
          </div>
          <b-alert
            v-else-if="!attachmentsSectionLoading"
            variant="info"
            show
            class="mb-0"
          >
            لا توجد مرفقات مطلوبة لهذا النوع من الخدمة.
          </b-alert>
        </div>
      </fieldset>
      <MethodSurveyComponent
        :project-id="project.id"
        :project="project"
      />
      <!-- <naturalSurveyMap
        :project-id="project.id"
        :project="project"
      /> -->
      <surveyor-acknowledgment-section
        v-if="project && project.id"
        :project-id="project.id"
        class="mt-2"
      />
    </b-card-body>
  </b-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import MethodSurveyComponent from './naturalSurveyComponent/MethodSurveyComponent.vue'
import naturalSurveyMap from './naturalSurveyComponent/naturalSurveyMap.vue'
import SurveyorAcknowledgmentSection from './Components/surveyor/SurveyorAcknowledgmentSection.vue'
import lookupAttachmentUpload from '@/mixins/lookupAttachmentUpload'
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BFormFile,
  BFormGroup,
  BSpinner,
  BAlert,
  BIcon,
  BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BFormFile,
    BFormGroup,
    BSpinner,
    BAlert,
    BIcon,
    BFormTextarea,
    ValidationProvider,
    vSelect,
    MethodSurveyComponent,
    naturalSurveyMap,
    SurveyorAcknowledgmentSection,
  },
  name: 'naturalSurvey',
  mixins: [lookupAttachmentUpload],
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      media: 'projects/media',
      loadMedia: 'projects/loadMedia',
      employees: 'employees/employees',
    }),
    employeeSelectOptions() {
      const fromApi = this.employees && this.employees.data
      const base = Array.isArray(fromApi) ? fromApi.filter(Boolean) : []
      const byId = new Map()
      const addEmp = emp => {
        if (emp == null || typeof emp !== 'object') return
        const id = Number(emp.id ?? emp.user_id)
        if (!Number.isInteger(id) || id <= 0) return
        if (!byId.has(id)) byId.set(id, emp)
      }
      base.forEach(addEmp)
      ;(this.currentInspectionTeams || []).forEach(addEmp)
      addEmp(this.currentInspectionResponsible)
      addEmp(this.currentDriver)
      return Array.from(byId.values())
    },
    canEditInspectionCrew() {
      return this.hasPermission('edit projects')
    },
    inspectionCrewBusy() {
      return !!(this.updatingInspectionTeams || this.loadingInspectionTeams)
    },
    ...mapGetters('attachmentLookups', {
      attachmentLookupsLoading: 'load',
    }),
    attachmentsSectionLoading() {
      return !!(this.loadMedia || this.attachmentLookupsLoading)
    },
    allFiles() {
      // Flatten all files from all groups into a single array (keep group key)
      if (!this.media || typeof this.media !== 'object') {
        return []
      }
      const allFilesArray = []
      for (const groupKey in this.media) {
        if (Array.isArray(this.media[groupKey])) {
          allFilesArray.push(
            ...this.media[groupKey].map(f => ({
              ...f,
              groupKey,
            })),
          )
        }
      }
      return allFilesArray
    },
    ...mapState('attachmentLookups', ['serviceTypesAttachmentLookups']),
    attachmentFields() {
      const lookups = this.serviceTypesAttachmentLookups || []
      const fields = []

      lookups.forEach((entry, sectionIndex) => {
        // Current API: { title, attachment_lookups: [{ id, key, name, name_ar, assignment_id, sort_order, is_active }] }
        if (entry && Array.isArray(entry.attachment_lookups)) {
          const groupTitle = entry.title != null ? String(entry.title) : 'عام'
          const groupKey = `section_${sectionIndex}_${this.normalizeName(groupTitle)}`
          const sectionSortOrder = this.pickGroupSortOrder(entry, sectionIndex)
          const sectionColor = this.pickGroupColor(entry)
          const items = [...entry.attachment_lookups].sort((a, b) => {
            const so = (a?.sort_order ?? 0) - (b?.sort_order ?? 0)
            if (so !== 0) return so
            return (a?.id ?? 0) - (b?.id ?? 0)
          })
          items.forEach((lookup, idx) => {
            if (!lookup || lookup.is_active === false) return
            const idPart = lookup.id != null ? lookup.id : idx
            const fieldKey = `lookup_${idPart}`
            const label =
              this.normalizeName(lookup.key)
              || this.normalizeName(lookup.name_ar)
              || this.normalizeName(lookup.name)
              || `attachment_${idPart}`
            fields.push({
              key: fieldKey,
              label,
              groupTitle,
              groupKey,
              groupOrder: sectionSortOrder,
              groupColor: sectionColor,
              lookup,
            })
          })
          return
        }

        const baseKey = entry?.key || `field_${sectionIndex}`
        const labelObj = this.coerceAttachmentLabel(entry?.label)
        const legacySectionOrder = this.pickGroupSortOrder(entry, sectionIndex)
        const legacySectionColor = this.pickGroupColor(entry)

        // Legacy: label is { "المساح": ["...", ...], ... } — collapse title = object key
        if (labelObj && typeof labelObj === 'object' && !Array.isArray(labelObj)) {
          Object.entries(labelObj).forEach(([gt, labels], mapIdx) => {
            if (!Array.isArray(labels)) return
            labels.forEach((label, labelIndex) => {
              fields.push({
                key: `${baseKey}_${this.normalizeName(gt)}_${labelIndex}`,
                label,
                groupTitle: String(gt),
                groupKey: `${baseKey}_${this.normalizeName(gt)}`,
                groupOrder: legacySectionOrder * 1000 + mapIdx,
                groupColor: legacySectionColor,
              })
            })
          })
          return
        }

        fields.push({
          key: baseKey,
          label: labelObj || entry,
          groupTitle: 'عام',
          groupKey: `${baseKey}_general`,
          groupOrder: legacySectionOrder,
          groupColor: legacySectionColor,
        })
      })

      return fields
    },
    attachmentGroups() {
      const groupsMap = {}

      this.attachmentFields.forEach(field => {
        if (!groupsMap[field.groupKey]) {
          const parsed = field.groupOrder != null ? Number(field.groupOrder) : NaN
          const order = Number.isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER
          groupsMap[field.groupKey] = {
            groupKey: field.groupKey,
            groupTitle: field.groupTitle || 'عام',
            order,
            color: field.groupColor ?? null,
            fields: [],
          }
        }
        groupsMap[field.groupKey].fields.push(field)
      })

      return Object.values(groupsMap).sort((a, b) => {
        if (a.order !== b.order) return a.order - b.order
        return String(a.groupKey).localeCompare(String(b.groupKey), 'ar')
      })
    },
  },
  data() {
    return {
      inspectionTeams: [],
      currentInspectionTeams: [],
      inspectionResponsibleId: null,
      currentInspectionResponsible: null,
      driverId: null,
      currentDriver: null,
      updatingInspectionTeams: false,
      loadingInspectionTeams: false,
      searchTimeout: null,
      lastLoadedServiceTypeId: null,
      fieldUploads: {},
      uploadingFields: {},
      localUploadedFiles: {},
      localDeletedFiles: {},
      localDeletedFileIds: {},
      editingNotes: {},
      notesEdit: {},
      savingNotes: {},
    }
  },
  mounted() {
    if (this.project?.id) {
      this.loadInspectionTeams()
      this.callEmployees('')
    }
  },
  watch: {
    project: {
      handler(newProject) {
        if (newProject) {
          this.applyInspectionCrewFrom(newProject, { fillEmptyOnly: true })
        }
      },
      immediate: true,
    },
    'project.service_type_id': {
      immediate: true,
      handler(serviceTypeId) {
        if (serviceTypeId) {
          this.init()
        }
      },
    },
    attachmentFields: {
      immediate: true,
      handler(fields) {
        fields.forEach(field => {
          if (!(field.key in this.fieldUploads)) {
            this.$set(this.fieldUploads, field.key, null)
          }
          if (!(field.key in this.uploadingFields)) {
            this.$set(this.uploadingFields, field.key, false)
          }
        })
      },
    },
  },
  methods: {
    ...mapActions('attachmentLookups', ['serviceTypesAttachments']),
    pickEmployeeId(value) {
      if (value == null || value === '') return null
      if (typeof value === 'object') {
        const id = Number(value.id ?? value.user_id)
        return Number.isInteger(id) && id > 0 ? id : null
      }
      const id = Number(value)
      return Number.isInteger(id) && id > 0 ? id : null
    },
    extractApiPayload(response) {
      if (!response) return {}
      if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
        if (response.data.data && typeof response.data.data === 'object' && !Array.isArray(response.data.data)) {
          return response.data.data
        }
        return response.data
      }
      return response
    },
    applyInspectionCrewFrom(source, { fillEmptyOnly = false } = {}) {
      if (!source || typeof source !== 'object') return

      if (Array.isArray(source.inspection_teams) && (!fillEmptyOnly || this.currentInspectionTeams.length === 0)) {
        this.currentInspectionTeams = source.inspection_teams.filter(Boolean)
        this.inspectionTeams = this.currentInspectionTeams.map(item => item.id || item)
      }

      const responsibleObj = source.office_inspection_responsible
      const responsibleId = this.pickEmployeeId(responsibleObj) || this.pickEmployeeId(source.office_inspection_responsible_id)
      if (responsibleId && (!fillEmptyOnly || this.inspectionResponsibleId == null)) {
        this.inspectionResponsibleId = responsibleId
        this.currentInspectionResponsible = responsibleObj && typeof responsibleObj === 'object'
          ? responsibleObj
          : this.currentInspectionResponsible
      }

      const driverObj = source.driver
      const driverId = this.pickEmployeeId(driverObj) || this.pickEmployeeId(source.driver_id)
      if (driverId && (!fillEmptyOnly || this.driverId == null)) {
        this.driverId = driverId
        this.currentDriver = driverObj && typeof driverObj === 'object'
          ? driverObj
          : this.currentDriver
      }
    },
    employeeOptionReduce(option) {
      if (option == null || typeof option !== 'object') return null
      return option.id ?? null
    },
    sanitizeTeamIds(teamIds) {
      if (!Array.isArray(teamIds)) return []
      return teamIds
        .map(id => Number(id))
        .filter(id => Number.isInteger(id) && id > 0)
    },
    employeeOptionLabel(option) {
      if (option == null || typeof option !== 'object') return ''
      return option.full_name || option.name || ''
    },
    async loadInspectionTeams() {
      if (!this.project?.id) return
      this.loadingInspectionTeams = true
      try {
        const response = await this.$store.dispatch('projects/getInspectionTeams', {
          id: this.project.id,
        })
        const payload = this.extractApiPayload(response)
        this.applyInspectionCrewFrom(payload)
        this.applyInspectionCrewFrom(this.project, { fillEmptyOnly: true })
      } catch (error) {
        console.error('Failed to load inspection teams:', error)
        this.applyInspectionCrewFrom(this.project)
      } finally {
        this.loadingInspectionTeams = false
      }
    },
    callEmployees(search) {
      const query = search ? { search } : {}
      this.$store.dispatch('employees/listEmployees', { query })
    },
    onEmployeeSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) {
        loading(true)
      }
      this.searchTimeout = setTimeout(() => {
        this.callEmployees(search)
        if (loading && typeof loading === 'function') {
          loading(false)
        }
      }, 300)
    },
    async updateInspectionTeams() {
      if (!this.project?.id || this.updatingInspectionTeams) return

      this.updatingInspectionTeams = true
      try {
        const payload = {
          inspection_team_ids: this.sanitizeTeamIds(this.inspectionTeams),
          office_inspection_responsible_id: this.pickEmployeeId(this.inspectionResponsibleId),
          driver_id: this.pickEmployeeId(this.driverId),
        }

        const response = await this.$store.dispatch('projects/updateInspectionTeams', {
          id: this.project.id,
          query: payload,
        })

        const updated = this.extractApiPayload(response)
        this.applyInspectionCrewFrom(updated)
        await this.loadInspectionTeams()

        this.$toast.success('تم تحديث فريق المعاينة بنجاح')
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'فشل تحديث فريق المعاينة'
        this.$toast.error(errorMessage)

        await this.loadInspectionTeams()
      } finally {
        this.updatingInspectionTeams = false
      }
    },
    isUploadingConditional(key) {
      return !!(this.uploadingFields && this.uploadingFields[key])
    },
    canPreviewFile(file) {
      return !!(file && (file.is_image || file.is_video || file.is_document))
    },
    startEditingNote(file) {
      if (!file || !file.id) return
      this.$set(this.editingNotes, file.id, true)
      this.$set(this.notesEdit, file.id, file.notes || '')
    },
    cancelEditingNote(fileId) {
      this.$set(this.editingNotes, fileId, false)
      this.$set(this.notesEdit, fileId, '')
    },
    async saveNote(file) {
      if (!file || !file.id) return
      const notes = (this.notesEdit[file.id] || '').trim()
      this.$set(this.savingNotes, file.id, true)

      try {
        await this.$store.dispatch('media/addNote', {
          id: file.id,
          notes,
        })

        this.$store.commit('projects/UPDATE_FILE_NOTES', {
          fileId: file.id,
          notes,
        })

        Object.keys(this.localUploadedFiles).forEach(key => {
          const localFile = this.localUploadedFiles[key]
          if (localFile && localFile.id === file.id) {
            this.$set(this.localUploadedFiles, key, { ...localFile, notes })
          }
        })

        this.$toast.success('تم حفظ الملاحظات بنجاح')
        this.$set(this.editingNotes, file.id, false)
        this.$set(this.notesEdit, file.id, '')
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'فشل في حفظ الملاحظات')
      } finally {
        this.$set(this.savingNotes, file.id, false)
      }
    },
    normalizeName(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, ' ')
    },
    /** Resolve group sort index from common API shapes (camelCase + snake_case + nested department). */
    pickGroupSortOrder(entry, sectionIndex) {
      const dept = entry?.attachment_department
      const raw =
        entry?.order ??
        entry?.sort_order ??
        entry?.display_order ??
        entry?.group_order ??
        dept?.order ??
        dept?.sort_order ??
        dept?.display_order ??
        dept?.group_order
      const n = raw != null ? Number(raw) : NaN
      return Number.isFinite(n) ? n : sectionIndex
    },
    /** Resolve group accent color from common API shapes. */
    pickGroupColor(entry) {
      const dept = entry?.attachment_department
      const raw =
        entry?.color ??
        entry?.colour ??
        entry?.hex_color ??
        entry?.accent_color ??
        dept?.color ??
        dept?.colour ??
        dept?.hex_color ??
        dept?.accent_color
      if (raw == null || raw === '') return null
      return typeof raw === 'string' ? raw.trim() : String(raw).trim()
    },
    /** Allow hex / rgb(a) / hsl(a) from API for safe CSS variables */
    safeAttachmentGroupColor(color) {
      if (color == null || color === '') return null
      const t = typeof color === 'string' ? color.trim() : String(color).trim()
      if (/^#[0-9A-Fa-f]{3,8}$/.test(t)) return t
      if (/^[0-9A-Fa-f]{3}$/.test(t)) return `#${t}`
      if (/^[0-9A-Fa-f]{6}$/.test(t)) return `#${t}`
      if (/^rgba?\(\s*[\d.%\s,]+\s*\)$/i.test(t)) return t
      if (/^hsla?\(\s*[\d.%\s,]+\s*\)$/i.test(t)) return t
      return null
    },
    attachmentGroupCssVars(group) {
      const c = this.safeAttachmentGroupColor(group?.color)
      if (!c) return {}
      return { '--attachment-group-accent': c }
    },
    attachmentGroupAccentClass(group) {
      return this.safeAttachmentGroupColor(group?.color) ? 'attachment-field-group--accent' : ''
    },
    /** API may send `label` as object or as JSON string; keys (e.g. المساح) are collapse titles */
    coerceAttachmentLabel(raw) {
      if (raw == null) return raw
      if (typeof raw === 'string') {
        const t = raw.trim()
        if (t.startsWith('{') && t.endsWith('}')) {
          try {
            return JSON.parse(t)
          } catch (e) {
            return raw
          }
        }
        return raw
      }
      return raw
    },
    pickUploadedFile(responseData, fallbackLabel) {
      if (!responseData) return { name: fallbackLabel }

      if (Array.isArray(responseData)) {
        return responseData[0] || { name: fallbackLabel }
      }

      if (Array.isArray(responseData?.data)) {
        return responseData.data[0] || { name: fallbackLabel }
      }

      if (responseData?.data && typeof responseData.data === 'object') {
        return responseData.data
      }

      if (typeof responseData === 'object') {
        return responseData
      }

      return { name: fallbackLabel }
    },
    async deleteConditionalFile(key, fileId) {
      const markDeleted = () => {
        if (fileId) this.$set(this.localDeletedFileIds, fileId, true)
        const remaining = this.getConditionalFiles(key)
        if (!remaining.length) {
          this.$delete(this.localUploadedFiles, key)
          this.$set(this.localDeletedFiles, key, true)
        }
        if (this.$bvToast) {
          this.$bvToast.toast('تم حذف الملف بنجاح', {
            title: 'الرفع الحقلي',
            variant: 'success',
            solid: true,
          })
        }
      }

      const doDelete = async () => {
        if (!fileId) {
          markDeleted()
          return
        }
        await this.$store.dispatch('media/delete', { id: fileId })
        markDeleted()
      }

      if (!this.$swal) {
        try {
          await doDelete()
        } catch (error) {
          if (this.$bvToast) {
            this.$bvToast.toast(error?.response?.data?.message || 'تعذر حذف الملف', {
              title: 'الرفع الحقلي',
              variant: 'danger',
              solid: true,
            })
          }
        }
        return
      }

      this.$swal({
        title: 'هل انت متاكد من حذف هذا الملف',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#06284D',
        cancelButtonColor: '#d33',
        confirmButtonText: 'نعم',
        cancelButtonText: 'لا',
      }).then(async result => {
        if (!result.isConfirmed) return
        try {
          await doDelete()
        } catch (error) {
          this.$swal({
            icon: 'error',
            title: error?.response?.data?.message || 'تعذر حذف الملف',
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        }
      })
    },
    async refreshMediaOnly() {
      // Only refresh media without reloading everything
      await this.$store.dispatch('projects/media', { id: this.project?.id })
    },
    async handleFileActionRefresh(key) {
      this.$delete(this.localDeletedFiles, key)
      await this.refreshMediaOnly()
    },

    init() {

      const serviceTypeId = this.project?.service_type_id
      if (!serviceTypeId || this.lastLoadedServiceTypeId === serviceTypeId) {
        return
      }
      this.lastLoadedServiceTypeId = serviceTypeId

      this.serviceTypesAttachments({
        service_type_id: serviceTypeId,
      }).catch(error => {
        console.log(error)
      })
      this.$store.dispatch('projects/media', { id: this.project?.id })
    },
    submitFieldUpload(field) {
      const files = this.isFieldMultiple(field)
        ? this.getSelectedFilesForField(field)
        : this.getSelectedFilesForField(field).slice(0, 1)
      const validationMessage = this.validateLookupFiles(field, files)
      if (validationMessage) {
        if (this.$swal) {
          this.$swal({
            icon: 'error',
            title: validationMessage,
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        } else if (this.$bvToast) {
          this.$bvToast.toast(validationMessage, {
            title: 'الرفع الحقلي',
            variant: 'danger',
            solid: true,
          })
        }
        return
      }

      this.$set(this.uploadingFields, field.key, true)
      const { formData, isMultiple } = this.buildFieldUploadFormData(field, files)
      const action = isMultiple ? 'projects/uploadMultipleAttachments' : 'projects/uploadAttachments'
      const payload = {
        query: formData,
        id: this.project?.id,
      }

      this.$store.dispatch(action, payload)
        .then(async response => {
          this.$set(this.fieldUploads, field.key, null)
          const uploadedFiles = this.pickUploadedFilesFromResponse(response?.data, field.label)
          this.$delete(this.localDeletedFiles, field.key)
          uploadedFiles.forEach(item => {
            if (item?.id) this.$delete(this.localDeletedFileIds, item.id)
          })
          this.$set(
            this.localUploadedFiles,
            field.key,
            isMultiple
              ? uploadedFiles
              : uploadedFiles[0]
                ? { ...uploadedFiles[0], name: uploadedFiles[0]?.name || field.label }
                : null,
          )
          await this.refreshMediaOnly()
          if (this.$bvToast) {
            this.$bvToast.toast('تم حفظ الملف بنجاح', {
              title: 'الرفع الحقلي',
              variant: 'success',
              solid: true,
            })
          }
        })
        .catch(error => {
          const message = this.lookupUploadErrorMessage(error)
          if (this.$swal) {
            this.$swal({
              icon: 'error',
              title: message,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
            return
          }
          if (this.$bvToast) {
            this.$bvToast.toast(message, {
              title: 'الرفع الحقلي',
              variant: 'danger',
              solid: true,
            })
          }
        })
        .finally(() => {
          this.$set(this.uploadingFields, field.key, false)
        })
    },
  },
  filters: {
    formatJalali(value) {
      if (!value) return ''
      const date = new Date(value)
      return date.toLocaleDateString('ar-EG')
    },
  },
}
</script>
<style scoped>
.required-block-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
}
.btnSM {
  padding: 0.2rem 0.2rem !important;
}
.media-card {
  border-radius: 12px;
  transition: box-shadow .2s;
  position: relative;
  width: 190px;
  min-height: 220px;
}
.media-card:hover {
  box-shadow: 0 6px 32px #3B82F640;
}
.media-card-thumb {
  width: 180px;
  height: 135px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #F8FAFC;
  overflow: hidden;
  margin-bottom: 10px;
}
.media-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #ececec;
}
.file-title {
  font-size: 0.97rem;
  font-weight: 500;
  color: #172b38;
}
.file-meta {
  font-size: 0.8rem;
}
.media-card-actions .b-button + .b-button {
  margin-left: 7px;
}
.gap-1 { gap: .4rem; }

.media-card-notes {
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
}

.notes-display {
  width: 100%;
}

.notes-content {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}

.notes-text {
  font-size: 0.875rem;
  color: #495057;
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
}

.notes-edit textarea {
  font-size: 0.875rem;
  resize: vertical;
}

@media (max-width: 768px) {
  .media-card-notes {
    padding-top: 0.5rem;
  }

  .notes-content {
    padding: 0.4rem;
    margin-bottom: 0.4rem;
  }

  .notes-text {
    font-size: 0.8rem;
  }

  .notes-edit textarea {
    font-size: 16px;
  }

  .notes-edit .d-flex {
    flex-direction: column;
  }

  .notes-edit .flex-fill {
    width: 100%;
    margin-bottom: 0.25rem;
  }
}

@media (max-width: 767.98px) {
  .required-block-cards {
    gap: 0.5rem;
    justify-content: space-between;
  }
  .media-card {
    flex: 0 0 calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
    min-height: auto !important;
  }
  .media-card-thumb {
    width: 100%;
    height: 90px;
  }
  .file-title {
    font-size: 0.85rem;
  }
  .file-meta {
    font-size: 0.72rem;
  }
  .media-card-actions {
    gap: 0.2rem;
    max-width: 100%;
  }
  .media-card-actions .b-button + .b-button,
  .media-card-actions .btn + .btn {
    margin-left: 0.2rem;
    margin-inline-start: 0.2rem;
  }
  .media-card-actions .b-button,
  .media-card-actions .btn {
    padding: 0.15rem 0.3rem !important;
    min-width: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  .media-card-actions .b-button svg,
  .media-card-actions .btn svg,
  .media-card-actions .feather-icon svg {
    width: 11px !important;
    height: 11px !important;
  }
  .media-card .d-flex.align-items-center.gap-1 > .btn {
    padding: 0.2rem 0.35rem !important;
    min-width: 1.65rem;
    width: 1.65rem;
    height: 1.65rem;
  }
}

.natural-survey-fieldset {
  min-width: 0;
  margin: 0.65rem 0 0.85rem;
  padding: 0.85rem 1rem 1rem;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  direction: ltr;
}

.natural-survey-fieldset > .natural-survey-fieldset__legend {
  float: none !important;
  display: table;
  width: auto !important;
  max-width: calc(100% - 1.5rem);
  margin: 0 0 0 0.75rem !important;
  padding: 0 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  color: #5e5873;
  background-color: #fff;
}



.attachment-field-group--accent {
  border-color: var(--attachment-group-accent);
  border-inline-start-width: 4px;
}

.attachment-field-group--accent .natural-survey-fieldset__legend {
  color: var(--attachment-group-accent);
}

.inspection-crew .form-group {
  margin-bottom: 0.35rem;
}

.inspection-crew ::v-deep .col-form-label {
  font-size: 0.8rem;
  font-weight: 600;
  padding-bottom: 0.2rem;
}

.inspection-crew ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
}

.inspection-crew__save-col {
  margin-bottom: 0.15rem;
}

.inspection-crew__save {
  min-height: 38px;
}

@media (min-width: 992px) {
  .inspection-crew__save-col {
    display: flex;
    align-items: flex-end;
  }
}
</style>